import { useTranslation } from "react-i18next";
import { Col, Row, Table } from "react-bootstrap";
import { Pagination } from "../pagination/Pagination";
import { TableRow } from "./TableRow";
import IPeopleTableProps from "./IPeopleTableProps";

export const PeopleTable = (props: IPeopleTableProps) => {
    const { t } = useTranslation();
    const { people, pages, page, onPageClicked, openModal } = props;

    const pageSize = 10;
    
    const safePage = pages > 0
        ? Math.min(Math.max(page, 1), pages)
        : 1;
    
    const startIndex = (safePage - 1) * pageSize;
    
    const visiblePeople = people.slice(startIndex, startIndex + pageSize);

    return (
        <Row>
            <Col>
                <Table striped bordered hover>
                    <thead>
                        <tr>
                            <th>{t("people.table.headers.name")}</th>
                            <th>{t("people.table.headers.position")}</th>
                            <th>{t("people.table.headers.team")}</th>
                            <th>{t("people.table.headers.country")}</th>
                            <th>{t("people.table.headers.region")}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            visiblePeople.map((p, i) => <TableRow key={i} person={p} openModal={openModal} />)
                        }
                    </tbody>
                </Table>
                <Pagination current={page} total={pages} onPageClicked={onPageClicked} />
            </Col>
        </Row>
    );
};
